import styled from 'styled-components';
import { th } from 'style/theme';
import { motion } from 'framer-motion';
import { sizes } from 'style';

export const CountryDirectoryWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 40px;
`;

export const MembersGrid = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
`;

export const BackButton = styled.div`
  display: none;
  align-items: center;
  margin-right: auto;
  color: ${th('colors.turquoise')};
  cursor: pointer;

  :hover {
    color: #85e2e3;
  }

  > svg {
    margin-right: 10px;
  }

  @media ${sizes.tabletPortrait} {
    display: inline-flex;
  }
`;
